import React, {useEffect, useState} from 'react';
import {Button, Col, Row} from "react-bootstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faPlus} from "@fortawesome/free-solid-svg-icons";
import {Trash2} from "react-feather";
import GeraeteModal from "./GeraeteModal";
import {getToken} from "../../Utils/Common";

function Geraete(props) {

    const [devicesData, setDevicesData] = useState([]);
    const [geraeteData, setGeraeteData] = useState([]);

    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    useEffect(() => {

        async function fetchDevices() {

            let apiBody = {
                "token": getToken(), "data": {
                    "organisationID": sessionStorage.getItem("org")
                }
            }

            return await fetch(process.env.REACT_APP_BACKEND_API_URI + "mobileappbackend/getdevices", {
                method: 'POST', headers: {
                    'Content-type': 'application/json',
                }, body: JSON.stringify(apiBody),
            })
                .then((response) => response.json())
                .catch((error) => {
                    console.error('Error:', error);
                })
        }

        fetchDevices().then(data => {

            let devicesData = []

            devicesData = data.data.map((item) => {


                return {

                    "id": item.id, "title": item.name, "status": item.status

                }
            })


            setDevicesData(devicesData)
        })

    }, []);

    function isDeviceAlreadyThere(filteredDevicesDuplicates, id) {
        let found = false;
        for (let i = 0; i < filteredDevicesDuplicates.length; i++) {
            if (filteredDevicesDuplicates[i].id === id) {
                found = true
            }
        }
        return found
    }

    useEffect(() => {
        let filteredDevicesDuplicates = []
        for (let i = 0; i < props.geraeteData?.length; i++) {
            let deviceEntry = {
                "id": "", "name": ""
            }
            if (!isDeviceAlreadyThere(filteredDevicesDuplicates, props.geraeteData[i]?.id)) {
                deviceEntry.id = props.geraeteData[i]?.id
                deviceEntry.name = props.geraeteData[i]?.name
                filteredDevicesDuplicates.push(deviceEntry)
            }
        }
        setGeraeteData(filteredDevicesDuplicates)
    }, [props.originState, props.geraeteData]);

    function deleteDevice(id) {

        props.setIsChange(false)
        let newGeraeteData = geraeteData.filter(item => item.id !== id);
        setGeraeteData(newGeraeteData);
        while (props.geraeteData.length > 0) {
            props.geraeteData.pop()
        }
        newGeraeteData.map((item) => {
            props.geraeteData.push(item);
        })
    }

    function getGeraeteTableBody(geraeteData) {
        return geraeteData?.map((item) => (<tr key={item.id}>
            <td>{item.name}</td>
            {!props.originState && <td
                style={{
                    textAlign: "center"
                }}
            >
                <button
                    disabled={props.tstatus==="Akzeptiert"}
                    className="btn btn-danger" onClick={() => deleteDevice(item.id)}>
                    <Trash2/>
                </button>
            </td>}
        </tr>));
    }

    return (<>
        <Row>
            <Col>
                <label className="handwai-text-label-main add-bottom-0-margin">{"Betriebsmittel"}</label>
            </Col>
            {!props.originState && <Col className="add-flex-end">
                <Button onClick={handleShow}
                        disabled={props.tstatus==="Akzeptiert"}
                        className='handwai-btn-create'>
                    <FontAwesomeIcon icon={faPlus}/></Button>
            </Col>}
        </Row>
        <br/>
        <table id="geraeteTable" className="table handwai-white-text">
            <thead>
            <tr>
                <th>Bezeichnung</th>
                {!props.originState && <th
                    style={{
                        width: "25%"
                    }}
                >Löschen
                </th>}
            </tr>
            </thead>
            <tbody>{getGeraeteTableBody(geraeteData)}</tbody>
        </table>
        <GeraeteModal show={show}
                      handleClose={handleClose}
                      devicesData={devicesData}
                      setIsChange={props.setIsChange}
                      geraeteDataInfo={props.geraeteData}
                      setGeraeteData={setGeraeteData}
        />
    </>);
}

export default Geraete;
